module.exports = __webpack_public_path__ + "img/SKMJ_rest4.abc61ee8.jpg";